module.exports = __webpack_public_path__ + "img/cancel.e90379f3.svg";